<template>
  <footer class="bg-[#212924] text-white/80">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-12">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-8">
        <div class="space-y-4">
          <h4 class="text-white font-medium mb-4">À Propos</h4>
          <ul class="space-y-2 font-light">
            <li>
              <RouterLink to="/about" class="hover:text-white transition-colors"
                >Le Projet</RouterLink
              >
            </li>
            <li>
              <RouterLink to="/team" class="hover:text-white transition-colors"
                >L'Équipe</RouterLink
              >
            </li>
            <li>
              <RouterLink to="/partners" class="hover:text-white transition-colors"
                >Partenaires</RouterLink
              >
            </li>
          </ul>
        </div>
        <div class="space-y-4">
          <h4 class="text-white font-medium mb-4">Ressources</h4>
          <ul class="space-y-2 font-light">
            <li>
              <RouterLink to="/news" class="hover:text-white transition-colors"
                >Actualités</RouterLink
              >
            </li>
            <li>
              <RouterLink to="/documentation" class="hover:text-white transition-colors"
                >Documentation</RouterLink
              >
            </li>
            <li>
              <RouterLink to="/features" class="hover:text-white transition-colors"
                >Fonctionnalités</RouterLink
              >
            </li>
            <li>
              <RouterLink to="/help" class="hover:text-white transition-colors">Aide</RouterLink>
            </li>
            <li>
              <RouterLink to="/faq" class="hover:text-white transition-colors">FAQ</RouterLink>
            </li>
          </ul>
        </div>
        <div class="space-y-4">
          <h4 class="text-white font-medium mb-4">Légal</h4>
          <ul class="space-y-2 font-light">
            <li>
              <RouterLink to="/terms" class="hover:text-white transition-colors">CGU</RouterLink>
            </li>
            <li>
              <RouterLink to="/privacy" class="hover:text-white transition-colors"
                >Politique de confidentialité</RouterLink
              >
            </li>
            <li>
              <RouterLink to="/credits" class="hover:text-white transition-colors"
                >Crédits</RouterLink
              >
            </li>
          </ul>
        </div>
        <div class="space-y-4">
          <h4 class="text-white font-medium mb-4">Contact</h4>
          <ul class="space-y-2 font-light">
            <li>
              <a
                href="mailto:contact@bruitsdecouloir.org"
                class="hover:text-white transition-colors"
                >Email</a
              >
            </li>
            <li>
              <RouterLink to="/contact" class="hover:text-white transition-colors"
                >Formulaire de contact</RouterLink
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="mt-6 md:mt-12 pt-4 md:pt-8 border-t border-white/10">
        <div class="flex flex-col md:flex-row justify-between items-center gap-4">
          <p class="text-sm font-light">
            &copy; 2025 - Projet Bruits de Couloir, réalisé par
            <a href="https://www.mercurioimaging.com" class="hover:text-white transition-colors"
              >Mercurio Imaging</a
            >. Tous droits réservés.
          </p>
          <a
            href="/api/v1/blog-posts/rss.xml"
            target="_blank"
            class="text-sm font-light hover:text-white transition-colors flex items-center gap-2"
            title="Flux RSS"
          >
            <Rss class="w-4 h-4" />
            Flux RSS
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { Rss } from 'lucide-vue-next'

import { RouterLink } from 'vue-router'
</script>
